module.exports = __webpack_public_path__ + "img/type_file_icon.b766b1f5.svg";